import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { AssetCategoryToTextV2, useI18nValues } from '@/entities/assets';
import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';
import { Select } from '@/shared/uikitV2/Select';
import { Option, SelectProps } from '@/shared/uikitV2/Select/types';

export const SelectAssetCategory: FC<SelectProps> = (props) => {
  const { t } = useTranslation('entities/assets');
  const { category } = useI18nValues();
  const { options, ...componentProps } = props;

  const categoryOptions = useMemo(() => {
    const items: Option[] = options
      ? options.map(({ value }) => ({
          value,
          content: { label: category(value as AssetCategory) },
        }))
      : Object.entries(AssetCategoryToTextV2).map(([key, value]) => {
          return { value: key, content: { label: t(value) } };
        });

    return { options: items };
  }, [t]);

  return <Select options={categoryOptions.options} {...componentProps} />;
};
